import styles from './contentComponent.module.css'
import Projects from '../projects/Projects';

function ContentComponent() {
    return ( 
        <div className={styles.contentContainer}>
            <Projects/>
        </div>
        
     );
}

export default ContentComponent;